import { taxReturnFormVersionsUrl } from 'app/http/apiRoutes';
import httpApiApplication from 'app/http/httpApiApplication';

import { type FormVersionModel, type ModelCurrentAccountRequest } from '../types';

export const baseUrl = taxReturnFormVersionsUrl;
const baseUrlCurrentAccountRule = '/formcurrentaccountrules';

export function updateFormVersion(id: string, request: FormVersionModel) {
  return httpApiApplication.put(`${baseUrl}/${id}`, request);
}

export function deleteFormVersion(id: string) {
  return httpApiApplication.delete(`${baseUrl}/${id}`);
}

export function getFormStatementByTaxId(taxId: string, anio: number, periodicity: string) {
  const periodicityHeader = periodicity ? '?headerPeriodicity=' + periodicity : '';

  return httpApiApplication.get(`${baseUrl}/last/${taxId}/${anio}${periodicityHeader}`);
}

export const createFormVersion = (request: FormVersionModel) => {
  return httpApiApplication.post(baseUrl, request);
};

export const createCurrentAccountRule = (request: ModelCurrentAccountRequest) => {
  return httpApiApplication.post(baseUrlCurrentAccountRule, request);
};

export const deleteCurrentAccountRule = (id: string) => {
  return httpApiApplication.delete(`${baseUrlCurrentAccountRule}/${id}`);
};
